import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <header id="home" className="bento-grid">
            <div className="hero-content bento-cell hero-cell">
                <div className="hero-panel">
                    <h1>Proven Aviation Expertise for Your Success</h1>
                    <p>With years of frontline aviation experience, we provide the strategic vision and operational edge your enterprise needs to thrive.</p>
                </div>
            </div>
            <div className="bento-cell empty-cell hero-cell"></div>
        </header>
    );
};

export default Hero; 